import { reactive } from 'vue'

export const AppState = reactive({
  scrollCount: ""


})